.text-area__wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.text-area__header {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
}

.text-area__label-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.text-area__label {
  font-family: inherit;
  font-size: inherit;
  font-weight: var(--semibold);
}

.text-area__label.required::after {
  color: var(--color-red-600);
  content: "\2605";
  font-size: 0.5rem;
  margin-left: 0.25rem;
  vertical-align: top;
}

.text-area__sub-label {
  color: var(--color-grey-700);
  font-size: var(--font-size-text-non-essential);
}

.text-area__word-count {
  color: var(--color-grey-600);
  font-size: var(--font-size-text-non-essential);
}

.text-area__word-count--alert {
  color: var(--color-red-600);
  font-weight: bold;
}

.text-area {
  border-radius: 0.5rem;
  font-family: inherit;
  font-size: inherit;
  min-height: 5.25rem;
  overflow: hidden;
  padding: 0.5rem;
  resize: none;
  white-space: pre-wrap;
  width: 100%;
  word-wrap: break-word;
}

.text-area--oneLine {
  max-height: 2.5rem;
  min-height: 2.5rem;
}

.text-area.not-valid {
  border-color: var(--color-red-600);
}
